/* Snuzone Desktop Search Panel — v11
   v11: Produkt-Treffer als MERGE aus zwei Quellen:
        1) /search/suggest.json (Predictive-Engine, natives Prefix-Matching:
           "pab" -> Pablo) — noetig, weil options[prefix]=last von der vollen
           Storefront-Suche engine-seitig nicht mehr angewendet wird
           (verifiziert 08/2026: Query mit/ohne Prefix liefert identische Treffer).
        2) Volle Suche (templates/search.ajax.liquid) — Typo-Toleranz/Relaxation
           ("pablp" -> Pablo) bleibt erhalten.
        Dedupe per handle, Prefix-Treffer zuerst. Beide Requests laufen im selben
        suggest.json-Call bzw. parallel; der bestehende Query-Vorschlaege-Fetch
        wurde dafuer um resources[type]=product erweitert (kein Zusatz-Request).
        Wishlist: suggest.json liefert keine Varianten-ID — Herz wird trotzdem
        gerendert, die VID wird beim ersten Klick lazy via /products/{handle}.js
        nachgeladen.
   v10: mg/Beutel-Chip entfernt (nur noch mg/g); Quick Shop laesst das Panel
        offen (Proxy-Klick vom Outside-Close ausgenommen, Modal-Klicks ignoriert).
   Karten = nativer .grid-product-redesign Klon (identisch zur RV-Section),
   Quick-Shop via Proxy-Trigger-Pattern, Wishlist via Swym-API.
   Datei: assets/snuzone-search.js
*/
(function () {
  'use strict';

  var DESKTOP = window.matchMedia('(min-width: 990px)');
  var DEBOUNCE_MS = 180;

  var root, panel, overlay;
  var cfg = {};
  var elRecentWrap, elRecentGrid, elFallback;
  var elSugWrap, elSugList, elProductsGrid, elEmpty, elViewAll;
  var stateIdle, stateTyping;
  var activeInput = null;
  var debTimer = null;
  var ctrl = null;
  var LOCALE_PREFIX = '';
  var isOpen = false;
  var suppressClose = false; // Proxy-Klick des Quick Shops nicht als Outside-Click werten

  /* ── Icons (identisch zur RV-Section) ─────────────────────────────── */
  var ICON_HEART = '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7z"/></svg>';
  var ICON_ATC = '<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">'
    + '<circle cx="14" cy="14" r="14" fill="white"/>'
    + '<path fill-rule="evenodd" clip-rule="evenodd" d="M12.9864 7.62938C12.6556 8.31877 12.4258 9.52248 12.4258 11.5262H11.6036C11.6036 9.49021 11.8324 8.13548 12.2447 7.27637C12.4541 6.83997 12.7187 6.51494 13.04 6.30066C13.3639 6.08462 13.7172 6 14.07 6C14.4228 6 14.7761 6.08462 15.1 6.30066C15.4213 6.51494 15.6859 6.83997 15.8953 7.27637C16.3076 8.13548 16.5363 9.49021 16.5363 11.5262H15.7142C15.7142 9.52248 15.4844 8.31877 15.1535 7.62938C14.9914 7.29153 14.8133 7.0948 14.6425 6.98088C14.4744 6.86872 14.2863 6.8187 14.07 6.8187C13.8537 6.8187 13.6656 6.86872 13.4974 6.98088C13.3267 7.0948 13.1486 7.29153 12.9864 7.62938Z" fill="black"/>'
    + '<path fill-rule="evenodd" clip-rule="evenodd" d="M9.00521 9.06998H19.1306L20.1333 19.2858H7.99976L9.00521 9.06998ZM9.75069 9.88868L8.90639 18.4671H19.2269L18.3849 9.88868H9.75069Z" fill="black"/>'
    + '<circle cx="19.7395" cy="19.6952" r="3.2608" fill="white"/>'
    + '<path fill-rule="evenodd" clip-rule="evenodd" d="M19.4123 21.6518V17.7388H20.0645V21.6518H19.4123Z" fill="black"/>'
    + '<path fill-rule="evenodd" clip-rule="evenodd" d="M21.6965 20.0216H17.7835V19.3694H21.6965V20.0216Z" fill="black"/>'
    + '</svg>';

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents, cfg.moneyFormat); } catch (e) {}
    }
    var fmt = cfg.moneyFormat;
    function f(precision, thousands, decimal) {
      var n = (Number(cents) / 100).toFixed(precision);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var placeholder = match ? match[1] : 'amount';
    var value;
    switch (placeholder) {
      case 'amount_no_decimals': value = f(0, ',', '.'); break;
      case 'amount_with_comma_separator': value = f(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = f(0, '.', ','); break;
      case 'amount_with_space_separator': value = f(2, ' ', ','); break;
      default: value = f(2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function priceToCents(price) {
    if (price == null) return 0;
    if (typeof price === 'number') return price; // volle Suche / .js liefern Cents
    var n = String(price).replace(/[^\d.,]/g, '').replace(/\.(?=\d{3}\b)/g, '').replace(',', '.');
    var f = parseFloat(n);
    return isNaN(f) ? 0 : Math.round(f * 100);
  }

  function handleFromUrl(url) {
    var m = String(url || '').match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : '';
  }

  function resize540(src) {
    if (!src) return '';
    return String(src).replace(/(\.[^.\/]+)(\?[^?]*)?$/, '_540x$1$2');
  }

  function hasTagCI(tags, tag) {
    if (!tag || !Array.isArray(tags)) return false;
    var t = String(tag).toLowerCase();
    for (var i = 0; i < tags.length; i++) {
      if (String(tags[i]).toLowerCase() === t) return true;
    }
    return false;
  }

  /* ── Normalisierung der beiden Produkt-Quellen ────────────────────── */

  /* Volle Suche (templates/search.ajax.liquid v3): Cents, Boolean isNew */
  function normFull(p) {
    var priceCents = priceToCents(p.price);
    return {
      handle: p.handle || handleFromUrl(p.url),
      url: p.url || '',
      image: p.image || '',
      title: p.title || '',
      priceCents: priceCents,
      capCents: (typeof p.cap === 'number' && p.cap > priceCents) ? p.cap : null,
      id: p.id || '',
      vid: p.vid || '',
      available: p.available !== false,
      isNew: p.isNew === true
    };
  }

  /* Predictive (suggest.json): Preise als Strings, keine Varianten-ID */
  function normSuggest(p) {
    var priceCents = priceToCents(p.price);
    var capCents = priceToCents(p.compare_at_price_max);
    var img = p.image || (p.featured_image && p.featured_image.url) || '';
    return {
      handle: p.handle || handleFromUrl(p.url),
      url: p.url || '',
      image: img ? resize540(img) : '',
      title: p.title || '',
      priceCents: priceCents,
      capCents: (capCents > priceCents) ? capCents : null,
      id: p.id || '',
      vid: '', // suggest.json liefert keine Varianten-ID -> lazy beim Wishlist-Klick
      available: p.available !== false,
      isNew: hasTagCI(p.tags, cfg.newTag)
    };
  }

  /* ── Native Karte (Markup-Klon von custom-product-grid-item-clean,
        identisch zur RV-Section, ohne Reorder-Signale) ─────────────── */
  function cardHTML(o) {
    var url = o.url || '#';
    var hasSale = typeof o.capCents === 'number' && o.capCents > o.priceCents;
    var salePct = hasSale ? Math.round((1 - o.priceCents / o.capCents) * 100) : 0;

    var tags = '';
    if (hasSale && salePct > 0) {
      tags += '<div class="grid-product__tag grid-product__tag--sale">' + esc(cfg.saleLabel) + ' <span data-percent-pack>-' + salePct + '%</span></div>';
    }
    if (o.isNew && cfg.showBadge) {
      tags += '<div class="grid-product__tag grid-product__tag--new">' + esc(cfg.badgeLabel) + '</div>';
    }

    /* v11: Herz auch ohne vid rendern (Suggest-Treffer) — VID wird beim
       ersten Klick lazy via /products/{handle}.js nachgeladen */
    var heart = '';
    if (cfg.showHeart && o.id) {
      heart = '<button type="button"'
        + ' class="wishlist-button wishlist-button--icon"'
        + ' data-snz-wl'
        + ' data-product-id="' + o.id + '"'
        + ' data-variant-id="' + (o.vid || '') + '"'
        + ' data-product-url="' + esc(url) + '"'
        + ' aria-label="Add to wishlist">'
        + ICON_HEART
        + '</button>';
    }

    var props = '';
    if (o.mg) {
      props = '<ul class="grid-product__properties no-bullets">'
        + '<li>' + esc(o.mg) + '</li>'
        + '</ul>';
    }

    var price;
    if (hasSale) {
      price = '<span class="grid-regular-price">' + formatMoney(o.priceCents) + '</span>'
        + '<span class="grid-compare-price">' + formatMoney(o.capCents) + '</span>';
    } else {
      price = '<span>' + formatMoney(o.priceCents) + '</span>';
    }

    /* Bild: Positionierung inline — themeunabhängig, kein Clipping durch 0-Höhe-Wrapper */
    var image = '<div class="image-wrap" style="position: relative; height: 0; padding-bottom: 100%; overflow: hidden;">'
      + (o.image
        ? '<img class="grid-product__image" src="' + esc(o.image) + '" alt="' + esc(o.title) + '" loading="lazy"'
          + ' style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: contain; opacity: 1; display: block;">'
        : '')
      + '</div>';

    return '<div class="custom-grid-product grid-product grid-product-redesign"'
      + ' data-product-handle="' + esc(o.handle || '') + '">'
      + '<div class="grid-product__content">'

      + '<div class="grid-product__tag-list grid-product__tag-list--top">'
      + tags
      + heart
      + '</div>'

      + '<a href="' + esc(url) + '" class="grid-product__link">'
      + '<div class="grid-product__image-mask">'
      + image
      + '</div>'
      + '</a>'

      + '<div class="grid-product__meta">'
      + '<div class="grid-product__meta-part">'
      + props
      + '<a href="' + esc(url) + '" class="grid-product__title">' + esc(o.title) + '</a>'
      + (o.sub ? '<div class="grid-product__vendor">' + esc(o.sub) + '</div>' : '')
      + '<div class="product-price">' + price + '</div>'
      + '</div>'
      + '</div>'

      + (o.handle
        ? '<div class="mobile-add-to-cart pulse" data-mobile-add-to-cart data-handle="' + esc(o.handle) + '">' + ICON_ATC + '</div>'
        : '')

      + '</div>'
      + '</div>';
  }

  /* ── Recently Viewed ──────────────────────────────────────────────── */
  function readRV() {
    var raw;
    try { raw = localStorage.getItem('rv_products'); } catch (e) { return []; }
    if (!raw) return [];
    var arr;
    try { arr = JSON.parse(raw); } catch (e) { return []; }
    if (!Array.isArray(arr)) return [];
    return arr.map(function (it) {
      if (typeof it === 'string') return { handle: it, strength: null };
      if (it && it.handle) return it;
      return null;
    }).filter(Boolean);
  }

  function loadRecent() {
    var items = readRV().slice(0, cfg.recentLimit);
    if (!items.length) { showFallback(); return; }

    var fetches = items.map(function (it) {
      return fetch(LOCALE_PREFIX + '/products/' + encodeURIComponent(it.handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { return p ? { p: p, item: it } : null; })
        .catch(function () { return null; });
    });

    Promise.all(fetches).then(function (results) {
      var html = '';
      results.forEach(function (res) {
        if (!res) return;
        var p = res.p;
        var it = res.item;
        var img = (p.featured_image || (p.images && p.images[0]) || '');
        var isNew = Array.isArray(p.tags) && cfg.newTag && p.tags.indexOf(cfg.newTag) !== -1;
        html += cardHTML({
          handle: p.handle,
          url: LOCALE_PREFIX + '/products/' + p.handle,
          image: resize540(img),
          title: p.title,
          sub: it.strength || '',
          mg: it.mg || '',
          priceCents: p.price,
          capCents: (p.compare_at_price && p.compare_at_price > p.price) ? p.compare_at_price : null,
          id: p.id,
          vid: (p.variants && p.variants[0]) ? p.variants[0].id : '',
          isNew: isNew
        });
      });
      if (!html) { showFallback(); return; }
      elRecentGrid.innerHTML = html;
      if (elRecentWrap) elRecentWrap.hidden = false;
      if (elFallback) elFallback.hidden = true;
      markWishlist(elRecentGrid);
    });
  }

  function showFallback() {
    if (elRecentWrap) elRecentWrap.hidden = true;
    if (elFallback) elFallback.hidden = false;
    markWishlist(elFallback);
  }

  /* ── Vorschläge (suggest.json) ────────────────────────────────────── */
  function renderSuggestions(queries) {
    if (!elSugWrap || !elSugList) return;
    if (!queries || !queries.length) {
      elSugWrap.hidden = true;
      elSugList.innerHTML = '';
      stateTyping.classList.add('snzs-no-sugg');
      return;
    }
    elSugWrap.hidden = false;
    stateTyping.classList.remove('snzs-no-sugg');
    elSugList.innerHTML = queries.map(function (q) {
      var label = q.styled_text || q.text || '';
      var term = q.text || (q.styled_text ? q.styled_text.replace(/<[^>]+>/g, '') : '');
      var url = LOCALE_PREFIX + '/search?q=' + encodeURIComponent(term) + '&type=product';
      return '<a href="' + esc(url) + '" class="snzs-link">' + label + '</a>';
    }).join('');
  }

  /* ── Produkte (normalisierte Objekte aus dem Merge) ───────────────── */
  function renderProducts(products) {
    if (!elProductsGrid) return;
    if (!products || !products.length) {
      elProductsGrid.innerHTML = '';
      if (elEmpty) elEmpty.hidden = false;
      return;
    }
    if (elEmpty) elEmpty.hidden = true;

    elProductsGrid.innerHTML = products.map(cardHTML).join('');
    markWishlist(elProductsGrid);
  }

  function setViewAll(q) {
    if (!elViewAll) return;
    if (!q) { elViewAll.textContent = ''; elViewAll.removeAttribute('href'); return; }
    elViewAll.textContent = (cfg.viewAllLabel || 'View all results for “[query]”').replace('[query]', q);
    elViewAll.setAttribute('href', LOCALE_PREFIX + '/search?q=' + encodeURIComponent(q) + '&type=product');
  }

  /* ── Wishlist (Swym-API direkt, native .added/.heart-pulse States) ── */
  function swymReady(cb) {
    if (window._swat) { cb(window._swat); return; }
    if (window.SwymCallbacks) {
      window.SwymCallbacks.push(cb);
    } else {
      window.SwymCallbacks = [cb];
    }
  }

  function markWishlist(scope) {
    if (!cfg.showHeart || !scope) return;
    var buttons = scope.querySelectorAll('[data-snz-wl]');
    if (!buttons.length) return;
    swymReady(function (swat) {
      try {
        swat.fetch(function (items) {
          if (!Array.isArray(items)) return;
          var inList = {};
          items.forEach(function (i) { if (i && i.empi) inList[String(i.empi)] = true; });
          buttons.forEach(function (btn) {
            if (inList[btn.getAttribute('data-product-id')]) btn.classList.add('added');
          });
        });
      } catch (e) {}
    });
  }

  function doWishlist(btn) {
    swymReady(function (swat) {
      var payload = {
        epi: parseInt(btn.getAttribute('data-variant-id'), 10),
        empi: parseInt(btn.getAttribute('data-product-id'), 10),
        du: window.location.origin + btn.getAttribute('data-product-url')
      };
      try {
        if (btn.classList.contains('added')) {
          swat.removeFromWishList(payload, function () {
            btn.classList.remove('added');
          });
        } else {
          swat.addToWishList(payload, function () {
            btn.classList.add('added', 'heart-pulse');
            setTimeout(function () { btn.classList.remove('heart-pulse'); }, 450);
          });
        }
      } catch (err) {}
    });
  }

  /* v11: Suggest-Treffer haben keine Varianten-ID — beim ersten Klick
     lazy via /products/{handle}.js nachladen, dann normaler Flow */
  function onWishlistClick(btn) {
    var vid = btn.getAttribute('data-variant-id');
    if (vid && vid !== '') { doWishlist(btn); return; }

    var handle = handleFromUrl(btn.getAttribute('data-product-url'));
    if (!handle) return;
    fetch(LOCALE_PREFIX + '/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (p && p.variants && p.variants[0]) {
          btn.setAttribute('data-variant-id', p.variants[0].id);
          doWishlist(btn);
        }
      })
      .catch(function () {});
  }

  /* ── Quick-Shop (delegiert, Proxy-Trigger-Pattern) ────────────────
     Root Cause: der native Handler (picoapp ProductItem) bindet nur beim
     initialen app.mount() — die Panel-Karten entstehen später. Fix: ein
     bereits gemounteter nativer Trigger (außerhalb Panel + RV-Track) wird
     als Proxy geklickt; data-handle wird für den synchronen Klick-Moment
     getauscht → exakt der native Flow inkl. app.mount().
     Das Panel BLEIBT OFFEN (Kunde kann weiter aus den Vorschlaegen kaufen);
     der synthetische Proxy-Klick liegt ausserhalb des Overlays und wird
     deshalb per suppressClose-Flag vom Outside-Close ausgenommen.
     Fallback: Flow-Replikation. */
  function triggerQuickShop(handle) {
    var proxy = null;
    var candidates = document.querySelectorAll('[data-mobile-add-to-cart]');
    for (var i = 0; i < candidates.length; i++) {
      var c = candidates[i];
      if (!c.closest('.snzs-overlay') && !c.closest('.rv-track')) { proxy = c; break; }
    }

    if (proxy) {
      var originalHandle = proxy.getAttribute('data-handle');
      proxy.setAttribute('data-handle', handle);
      suppressClose = true;
      try { proxy.click(); } finally { suppressClose = false; }
      if (originalHandle !== null) {
        proxy.setAttribute('data-handle', originalHandle);
      } else {
        proxy.removeAttribute('data-handle');
      }
      return;
    }

    /* Fallback: nativen Flow replizieren (ohne app.mount-Garantie) */
    var rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) || (LOCALE_PREFIX + '/');
    fetch(rootPath + 'products/' + handle + '?view=ajax-product')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var modal = document.querySelector('.ModalForm');
        if (!modal) return;
        modal.innerHTML = html;
        modal.classList.add('active');

        var mClose = document.querySelector('[data-close-popup]');
        if (mClose) {
          mClose.addEventListener('click', function () {
            modal.classList.add('close-animation');
            setTimeout(function () {
              modal.classList.remove('close-animation');
              modal.classList.remove('active');
            }, 400);
            setTimeout(function () {
              var popup = document.querySelector('.product-custom-popup');
              if (popup) popup.remove();
            }, 500);
          });
        }

        if (window.app && typeof window.app.mount === 'function') {
          try { window.app.mount(); } catch (err) {}
        }
      })
      .catch(function () {});
  }

  function bindCardActions() {
    if (overlay.getAttribute('data-snz-actions') === '1') return;
    overlay.setAttribute('data-snz-actions', '1');

    overlay.addEventListener('click', function (e) {
      var wl = e.target.closest && e.target.closest('[data-snz-wl]');
      if (wl && overlay.contains(wl)) {
        e.preventDefault();
        e.stopPropagation();
        onWishlistClick(wl);
        return;
      }
      var atc = e.target.closest && e.target.closest('[data-mobile-add-to-cart]');
      if (atc && overlay.contains(atc)) {
        e.preventDefault();
        e.stopPropagation();
        var handle = atc.getAttribute('data-handle');
        if (handle) triggerQuickShop(handle);
      }
    });
  }

  /* ── State-Wechsel ────────────────────────────────────────────────── */
  function showIdle() {
    if (stateIdle) stateIdle.hidden = false;
    if (stateTyping) stateTyping.hidden = true;
  }
  function showTyping() {
    if (stateIdle) stateIdle.hidden = true;
    if (stateTyping) stateTyping.hidden = false;
  }

  function onType(q) {
    q = (q || '').trim();
    if (debTimer) clearTimeout(debTimer);
    if (q.length < 1) { showIdle(); return; }
    showTyping();
    debTimer = setTimeout(function () { runPredictive(q); }, DEBOUNCE_MS);
  }

  /* ── Predictive (v11: Merge Prefix + volle Suche) ─────────────────── */
  function runPredictive(q) {
    if (ctrl) { try { ctrl.abort(); } catch (e) {} }
    ctrl = (window.AbortController ? new AbortController() : null);
    var myCtrl = ctrl;
    var signal = ctrl ? ctrl.signal : undefined;

    /* 1) Volle Suche: Typo-Toleranz/Relaxation. options[prefix]=last bleibt
       im Request (harmlos; greift automatisch wieder, falls Shopify die
       Prefix-Regression behebt). */
    var fullP = fetch(
      LOCALE_PREFIX + '/search?q=' + encodeURIComponent(q)
        + '&type=product&options[prefix]=last&view=ajax',
      { credentials: 'same-origin', signal: signal }
    )
      .then(function (r) { return r.ok ? r.text() : '[]'; })
      .then(function (text) {
        try { return JSON.parse(text) || []; } catch (e) { return []; }
      })
      .catch(function () { return []; });

    /* 2) Predictive-Engine: natives Prefix-Matching (Produkte) + Query-
       Vorschlaege — ein Request fuer beides. */
    var sugLimit = Math.max(cfg.queryLimit, Math.min(cfg.productLimit, 10));
    var sugP = fetch(
      LOCALE_PREFIX + '/search/suggest.json'
        + '?q=' + encodeURIComponent(q)
        + '&resources[type]=query,product'
        + '&resources[limit]=' + sugLimit
        + '&resources[options][unavailable_products]=last',
      { credentials: 'same-origin', signal: signal }
    )
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });

    Promise.all([fullP, sugP]).then(function (res) {
      if (ctrl !== myCtrl) return; // veraltete Antwort verwerfen

      var full = res[0] || [];
      var sug = res[1];
      var results = (sug && sug.resources && sug.resources.results) || {};
      var sugProducts = results.products || [];
      var queries = results.queries || [];

      renderSuggestions(queries.slice(0, cfg.queryLimit));

      /* Merge: Prefix-Treffer (Predictive) zuerst, dann Zusatz-Treffer der
         vollen Suche (Typos/Relaxation). Dedupe per handle. */
      var seen = {};
      var merged = [];
      sugProducts.forEach(function (p) {
        var o = normSuggest(p);
        if (o.handle && !seen[o.handle]) { seen[o.handle] = 1; merged.push(o); }
      });
      full.forEach(function (p) {
        var o = normFull(p);
        if (o.handle && !seen[o.handle]) { seen[o.handle] = 1; merged.push(o); }
      });

      merged.sort(function (a, b) { return (b.available ? 1 : 0) - (a.available ? 1 : 0); });
      renderProducts(merged.slice(0, cfg.productLimit));
      setViewAll(q);
    });
  }

  /* ── Position / Open / Close ──────────────────────────────────────── */
  function positionPanel() {
    var container = document.querySelector('.site-header__search-container');
    var header = document.querySelector('.header-wrapper')
      || document.querySelector('.site-header')
      || document.querySelector('header');
    var anchor = header;
    if (container) {
      var cRect = container.getBoundingClientRect();
      if (cRect.height > 2 && cRect.bottom > 2) anchor = container;
    }
    if (!anchor) { overlay.style.top = '0px'; return; }
    var bottom = anchor.getBoundingClientRect().bottom;
    overlay.style.top = Math.max(0, Math.round(bottom)) + 'px';
  }

  function repositionLoop() {
    var n = 0;
    var id = setInterval(function () {
      positionPanel();
      if (++n >= 15) clearInterval(id);
    }, 30);
  }

  function open() {
    if (!DESKTOP.matches) return;
    if (isOpen) { positionPanel(); return; }
    isOpen = true;
    overlay.style.display = 'block';
    overlay.classList.add('snzs-open');
    positionPanel();
    repositionLoop();
    var val = activeInput ? activeInput.value : '';
    if (val && val.trim().length) { onType(val); } else { showIdle(); loadRecent(); }
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    overlay.style.display = 'none';
    overlay.classList.remove('snzs-open');
    if (debTimer) clearTimeout(debTimer);
  }

  function bindEvents() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest && e.target.closest('.js-search-header');
      if (opener) { setTimeout(open, 0); return; }
      var closer = e.target.closest && e.target.closest('.js-search-header-close');
      if (closer) { close(); return; }
      if (isOpen) {
        if (suppressClose) return;
        var inOverlay = overlay.contains(e.target);
        var inSearch = e.target.closest && e.target.closest('.site-header__search-container, .js-search-header');
        /* Quick-Shop-Modal gehoert zum Kaufvorgang – Panel offen lassen */
        var inModal = e.target.closest && e.target.closest('.ModalForm, .product-custom-popup');
        if (!inOverlay && !inSearch && !inModal) close();
      }
    }, true);

    document.addEventListener('focusin', function (e) {
      var inp = e.target.closest && e.target.closest('.site-header__search-input');
      if (inp) { activeInput = inp; setTimeout(open, 0); }
    });

    document.addEventListener('input', function (e) {
      var inp = e.target.closest && e.target.closest('.site-header__search-input');
      if (!inp) return;
      activeInput = inp;
      if (!isOpen) open();
      onType(inp.value);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) close();
    });

    window.addEventListener('resize', function () { if (isOpen) positionPanel(); });
    DESKTOP.addEventListener && DESKTOP.addEventListener('change', function (m) { if (!m.matches) close(); });
  }

  /* ── Init ─────────────────────────────────────────────────────────── */
  function readCfg() {
    cfg.recentLimit = parseInt(root.getAttribute('data-recent-limit'), 10) || 6;
    cfg.productLimit = parseInt(root.getAttribute('data-product-limit'), 10) || 8;
    cfg.queryLimit = parseInt(root.getAttribute('data-query-limit'), 10) || 4;
    cfg.newTag = root.getAttribute('data-new-tag') || 'neu';
    cfg.badgeLabel = root.getAttribute('data-badge-label') || 'Neu';
    cfg.showBadge = root.getAttribute('data-show-badge') !== 'false';
    cfg.showHeart = root.getAttribute('data-show-heart') === 'true';
    cfg.viewAllLabel = root.getAttribute('data-viewall-label') || 'View all results for “[query]”';
    cfg.moneyFormat = root.getAttribute('data-money-format') || '{{amount}}';
    cfg.saleLabel = root.getAttribute('data-sale-label') || 'Sale';
    LOCALE_PREFIX = (root.getAttribute('data-locale-root') || '').replace(/\/$/, '');
  }

  function init() {
    root = document.querySelector('[data-snz-search]');
    if (!root) return;
    overlay = root;
    panel = root.querySelector('.snzs-panel');

    stateIdle = root.querySelector('[data-snz-state="idle"]');
    stateTyping = root.querySelector('[data-snz-state="typing"]');
    elRecentWrap = root.querySelector('[data-snz-recent]');
    elRecentGrid = root.querySelector('[data-snz-recent-grid]');
    elFallback = root.querySelector('[data-snz-fallback]');
    elSugWrap = root.querySelector('[data-snz-suggestions]');
    elSugList = root.querySelector('[data-snz-suggestions-list]');
    elProductsGrid = root.querySelector('[data-snz-products-grid]');
    elEmpty = root.querySelector('[data-snz-empty]');
    elViewAll = root.querySelector('[data-snz-viewall]');

    readCfg();

    isOpen = false;
    overlay.style.display = 'none';
    overlay.classList.remove('snzs-open');

    if (overlay.parentNode !== document.body) document.body.appendChild(overlay);

    bindCardActions();
    bindEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-snz-search]')) {
      init();
    }
  });
})();